export default __webpack_public_path__ + "static/media/spectator-background.96279c34.webp";